import styled, { css } from 'styled-components'
import { media } from 'constants/media/media'
import { withFancyScrollbar } from 'helpers/styleHelpers/styleHelpers'
import { zIndex } from 'constants/zIndex/zIndex'

export const ListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
`

export const BasketContainer = styled.div`
	width: 100%;
	max-width: 37.5rem;
	display: none;

	${media.desktopLarge`
		display: initial;
	`}
`

export const SearchLabel = styled.label`
	display: none;
`

export const BasketFixed = styled.div`
	position: sticky;
	top: ${({ theme }) => theme.sizes.headerDesktop};
	height: ${({ theme }) => `calc(100vh - ${theme.sizes.headerDesktop})`};
	width: 100%;
	max-width: 37.5rem;
	border-left: 1px solid ${({ theme }) => theme.colors.borderLight};
	background-color: ${({ theme }) => theme.colors.white};
	z-index: ${zIndex.basketFixed};
	${withFancyScrollbar};
`

export const Wrapper = styled.div`
	max-width: calc(192rem - 37.5rem);
	padding: 0 3.75rem;
	width: 100%;
	margin: 4rem auto 12rem auto;
`
export const FilterColumn = styled.div`
	flex: 0 0 auto;
	width: 24rem;
	margin-right: 3rem;
	margin-bottom: 8rem;
`

export const ListColumn = styled.div`
	width: 100%;
`

export const MobileFilterButtonWrapper = styled.div`
	${media.desktopSmall`
		display: none;
	`}
	${media.mobileOnly`
		> * {
			margin-top: 3rem;
		}
	`}
`

export const FilterSubHeading = styled.div`
	color: ${({ theme }) => theme.colors.secondary};
	text-align: center;
	font-size: 1.5rem;
	font-weight: 600;
	cursor: pointer;

	&:hover {
		color: ${({ theme }) => theme.colors.secondaryDark};
	}
`

export const TitleTreeWrapper = styled.div`
	${media.mobileOnly`
		> * {
			margin: 2.5rem 1rem;
			font-weight: 800;
			font-size: 2.8rem;
			line-height: 2.4rem;
		}
	`}
`

export const ProductFilterChipsStyles = styled.div`
	padding: 0 2rem;
	max-width: 100vw;
	overflow-x: auto;
	display: flex;
	justify-items: space-between;
	align-content: stretch;
	-ms-overflow-style: none; /* IE and Edge */
	scrollbar-width: none; /* Firefox */
	&::-webkit-scrollbar {
		display: none;
	}
`

export const MobileSearchPadder = styled.div`
	margin-bottom: 2.5rem;
	height: 5rem;

	${media.desktopSmall`
		display: none;
	`}
`

export const MobileFiltersWrapper = styled.div`
	display: flex;
	justify-items: space-between;
	align-content: stretch;
	flex-direction: column;
	margin-top: 2rem;
	background-color: ${({ theme }) => theme.colors.white};
	${media.desktopSmall`
		display: none;
	`}
`

export const FilterHeader = styled.div`
	position: relative;
`
interface BackButtonProps {
	active: boolean
}

export const BackButton = styled.div<BackButtonProps>`
	visibility: visible;
	${({ active }) =>
		active &&
		css`
			visibility: hidden;
		`}
`

interface ClearButtonProps {
	hidden?: boolean
}

export const ClearButton = styled.div<ClearButtonProps>`
	opacity: ${({ hidden }) => (hidden ? '0' : '1')};
	display: flex;
	justify-content: flex-end;
	padding: 1.5rem 1.5rem;
	transition: all 0.25s ease-in-out;
`
export const InnerWrapper = styled.div``

export const MainTreeFilterWrapper = styled.div`
	${media.tabletAndMobileOnly`
    display: none;
`}
`
